import { useContext } from 'react';
import GoogleLoginButton from '../google/GoogleLoginButton';
import { MicrosoftLoginButton } from '../microsoft/MicrosoftLoginButton';
import AppleLoginButton from '../apple/AppleLoginButton';
import { SmartLoginLandingPageContext } from './SmartLoginLandingPageContext';
import { useLoginRequirementsData } from 'LoginUI/hooks/useLoginRequirementsData';
import { useMicrosoftLogin } from 'LoginUI/hooks/useMicrosoftLogin';
import { useGoogleLogin } from 'LoginUI/hooks/useGoogleLogin';
import { useAppleLogin } from 'LoginUI/hooks/useAppleLogin';
import { useSsoLogin } from 'LoginUI/hooks/useSsoLogin';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/components/View';
import { Spacer } from 'foundations-components/components/Spacer';
import { getIsChatSpot } from 'LoginUI/utils/urls';
import { trackSmartLoginAppleLogin, trackSmartLoginGoogleLogin, trackSmartLoginMicrosoftLogin, trackSmartLoginSsoLogin } from 'LoginUI/lib/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SmartLoginOptionColumn = () => {
  const {
    email,
    loginRedirectUrl,
    loginPortalId,
    additionalSsoPortal,
    availableLogins,
    loginRequirementPortalId,
    setError,
    isEmailSet,
    rememberLogin
  } = useContext(SmartLoginLandingPageContext);
  const {
    isSSOAvailable,
    isGoogleAvailable,
    isMSAvailable,
    isAppleAvailable,
    requiredPortalId
  } = useLoginRequirementsData({
    additionalSsoPortal,
    availableLogins,
    loginRequirementPortalId
  });
  const {
    loginWithMicrosoft
  } = useMicrosoftLogin({
    requiredPortalId,
    handleError: setError,
    rememberLogin
  });
  const {
    loginWithGoogle
  } = useGoogleLogin({
    requiredPortalId,
    handleError: setError,
    rememberLogin
  });
  const {
    loginWithSso
  } = useSsoLogin({
    email,
    loginPortalId: additionalSsoPortal || requiredPortalId || loginPortalId,
    loginRedirectUrl,
    handleError: setError,
    rememberLogin
  });
  const {
    loginWithApple
  } = useAppleLogin({
    requiredPortalId,
    handleError: setError,
    rememberLogin
  });
  const isChatSpot = getIsChatSpot();
  const ssoButtonVisible = !isChatSpot || isSSOAvailable;
  return /*#__PURE__*/_jsxs(View, {
    inlineSize: "370px",
    marginBlockStart: "400",
    marginBlockEnd: "800",
    children: [/*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(GoogleLoginButton, {
      disabled: !isGoogleAvailable,
      onClick: () => {
        trackSmartLoginGoogleLogin(email, 'control');
        loginWithGoogle();
      },
      tooltipDisabled: isEmailSet,
      smartLogin: true
    }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(MicrosoftLoginButton, {
      onClick: () => {
        trackSmartLoginMicrosoftLogin(email, 'control');
        loginWithMicrosoft();
      },
      disabled: !isMSAvailable,
      tooltipDisabled: isEmailSet,
      smartLogin: true
    }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(AppleLoginButton, {
      onClick: () => {
        trackSmartLoginAppleLogin(email, 'control');
        loginWithApple();
      },
      disabled: !isAppleAvailable,
      tooltipDisabled: isEmailSet,
      smartLogin: true
    }), /*#__PURE__*/_jsx(Spacer, {}), ssoButtonVisible && /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "login.smartLogin.disabledButtonHelp"
      }),
      disabled: isEmailSet,
      children: /*#__PURE__*/_jsx(Button, {
        block: true,
        "data-test-id": "sso-login-button",
        id: "ssoBtn",
        type: "button",
        use: "tertiary",
        onClick: () => {
          trackSmartLoginSsoLogin(email, 'control');
          loginWithSso();
        },
        disabled: !isSSOAvailable,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "login.form.sso.loginButton"
        })
      })
    })]
  });
};
export default SmartLoginOptionColumn;